"use client"
import { useState, useRef, useEffect } from "react"
import { CaretDown as ChevronDown } from "@phosphor-icons/react"
import "./active-time-mode-select.css"
export function ActiveTimeModeSelect({day, value, disabled, onChange}: {day: string; value: string; disabled?: boolean; onChange: (value: string) => void}) {
  const [open, setOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)
  const options = [
    {value: "all", label: "全天允许"},
    {value: "custom", label: "自定义时段"},
    {value: "none", label: "当天不允许"},
  ]
  const selected = options.find(option => option.value === value) ?? options[0]

  useEffect(() => {
    const handlePointerDown = (event: PointerEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) setOpen(false)
    }
    document.addEventListener("pointerdown", handlePointerDown)
    return () => document.removeEventListener("pointerdown", handlePointerDown)
  }, [])

  return <div className="active-time-mode" ref={rootRef}>
    <button type="button" className="active-time-mode-trigger" aria-haspopup="listbox" aria-expanded={open} onClick={() => setOpen(current => !current)} onKeyDown={event => { if (event.key === "Escape") setOpen(false) }} disabled={disabled}>
      <span>{selected.label}</span><ChevronDown size={15} aria-hidden="true" />
    </button>
    {open && <div className="active-time-mode-menu motion-panel" role="listbox" aria-label={`${day}允许上号模式`}>
      {options.map(option => <button type="button" role="option" aria-selected={option.value === value} className="active-time-mode-option" key={option.value} onClick={() => { onChange(option.value); setOpen(false) }}>
        <span>{option.label}</span>{option.value === value && <span className="active-time-check" aria-hidden="true">✓</span>}
      </button>)}
    </div>}
  </div>
}
